module.exports = __webpack_public_path__ + "static/media/map.cb6223d4.jpg";